






























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { formatTime, setDateFromTime } from '@/utils/helpers'

@Component
export default class TimePicker extends Vue {
  @Prop(String) label!: string
  @Prop(Date) value?: Date
  @Prop(Boolean) disabled?: boolean
  @Prop(String) min?: string
  @Prop() rules?: ((value: Date) => boolean | string)[]
  time = this.value ? formatTime(this.value.toLocaleString('he-IL')) : ''
  menu = false

  @Watch('time')
  onTimeChanged () {
    const newTime = new Date(this.value || new Date())
    const submitTime = setDateFromTime(this.time, newTime)
    this.$emit('input', submitTime)
  }
}
